import * as React from 'react';
import {assets} from "../../helpers";
import {UserRegister} from "../forms/UserRegister";
import {Dialog} from "../Dialog";
import * as ReactPlayer from 'react-player';

export class MainBanner extends React.Component<{compact?: boolean}, any> {
    constructor(props) {
        super(props);
        this.state = {
            playing: false
        };
    }
    
    /*private open(e) {
        e.preventDefault();
        this.setState({open: true});
        window.scrollTo(0, 0);
    }*/
    
    private playPause = (e) => {
        this.setState({playing: !this.state.playing});
    };
    
    render() {
        const banner = this.props.compact ? assets("bn-2016-min.png") : assets("bn-2016.png");
        return (
            <div>
                <section id="bn-2016" className="heading">
                    <a href="https://doctorhead.ru/promo/loudhead-competition/" target="_blank"><img src={assets("competition-1.png")} width="100%" /></a>
                </section>
                <div id="player" onClick={this.playPause}>
                    <h1>Видео с выставки LOUDHEAD 2016</h1>
                    {this.state.playing === false && <div className="play">&nbsp;</div>}
                    <ReactPlayer fileConfig={{controls: true}} className="player" url="/video/2016.mp4" playing={this.state.playing} width="100%" height="auto" />
                </div>
            </div>
            /*<section id="bn-2016" className="heading">
                
                <a href="#" onClick={e => this.open(e)}><img src={banner} width="100%" /></a>
                <img src={banner} width="100%" />
                <Dialog key={this.state.open} open={this.state.open} onClose={e => this.setState({open: false})}>
                    <UserRegister />
                </Dialog>
            </section>*/
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/banners/MainBanner.tsx
 **/